import { render, staticRenderFns } from "./SeminarTrailer.vue?vue&type=template&id=60c6d408&scoped=true&"
import script from "./SeminarTrailer.vue?vue&type=script&lang=js&"
export * from "./SeminarTrailer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c6d408",
  null
  
)

export default component.exports